// TapSake Core — modular router + cap registry (FULL DROP-IN)
// v1.5 (LAZY CAPS FIRST-CLASS + safer activation/unclaimed flow)
// ✅ Supports ?code= / ?g= / #CODE / #code=CODE
// ✅ Fetch timeout (10s)
// ✅ NO auto-start (hub starts it)
// ✅ Device-unlock support: unclaimed + unlocked => render claimed
// ✅ Lazy-load cap JS by type: TS_CONFIG.CAP_URLS + TS_SHARED.loadScriptOnce
// ✅ Aliases: recommendations, emergency, guestbook, process_tracker, etc.

(function () {
  "use strict";

  // ---------- Namespace ----------
  window.TS = window.TS || {};
  const TS = window.TS;

  TS.caps = TS.caps || {};

  // ---------- Logging ----------
  const log = (...a) => console.log("[TapSake]", ...a);
  const warn = (...a) => console.warn("[TapSake]", ...a);
  const err = (...a) => console.error("[TapSake]", ...a);

  log("ts-core.js loaded ✅ (v1.5)");

    /* ======================
     Global Font: Inter (all caps)
     ====================== */
  (function loadInterFontGlobal() {
    if (document.getElementById("ts-inter-font")) return;

    var link = document.createElement("link");
    link.id = "ts-inter-font";
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap";
    document.head.appendChild(link);
  })();

  (function injectGlobalInterStyles() {
  if (document.getElementById("ts-global-inter")) return;

  var style = document.createElement("style");
  style.id = "ts-global-inter";
  style.textContent = `
    /* Global Inter for ALL TapSake caps (safe: only inside #ts-card) */
    #ts-card, #ts-card * {
      font-family: "Inter", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial,
        "Apple Color Emoji", "Segoe UI Emoji" !important;
    }

    /* OPTIONAL: keep your Gift-style serif title (prevents “looks terrible” moments) */
    #ts-card .ts-title,
    #ts-card .ts-title * {
      font-family: "Playfair Display", Georgia, "Times New Roman", serif !important;
    }
  `;
  document.head.appendChild(style);
})();



  // ---------- Helpers ----------
  TS.q =
    TS.q ||
    function q(key) {
      try {
        return new URLSearchParams(window.location.search).get(key);
      } catch (e) {
        return null;
      }
    };

  // Read code from hash (when Messenger strips query params)
  TS.hashCode =
    TS.hashCode ||
    function hashCode() {
      try {
        const h = String(window.location.hash || "").replace(/^#/, "").trim();
        if (!h) return "";

        // #code=ABCD1234
        const m = h.match(/(?:^|[&?])code=([A-Za-z0-9]{4,32})(?:$|[&?])/i);
        if (m && m[1]) return String(m[1]).toUpperCase().replace(/[^A-Z0-9]/g, "");

        // #ABCD1234
        if (/^[A-Za-z0-9]{4,32}$/.test(h))
          return String(h).toUpperCase().replace(/[^A-Z0-9]/g, "");

        return "";
      } catch (e) {
        return "";
      }
    };

  TS.getCode =
    TS.getCode ||
    function getCode() {
      const qCode = String(TS.q("code") || TS.q("g") || TS.q("ts_code") || TS.q("tsCode") || "")
        .trim()
        .toUpperCase();
      if (qCode) return qCode;

      const hCode = String(TS.hashCode() || "").trim().toUpperCase();
      return hCode || "";
    };

  TS.normType =
    TS.normType ||
    function normType(type) {
      let t = String(type || "").trim().toLowerCase();

      const alias = {
        businesscard: "business",
        business_card: "business",
        biz: "business",

        petcare: "pet_care",
        "pet-care": "pet_care",

        lovenotes: "love_notes",
        "love-notes": "love_notes",
        love_note: "love_notes",
        love: "love_notes",

        prayer: "prayer",

        prayerboard: "prayer_board",
        prayer_board: "prayer_board",
        "prayer-board": "prayer_board",

        recipebook: "recipe_book",
        recipe_book: "recipe_book",
        "recipe-book": "recipe_book",
        recipes: "recipe_book",

        // bucket list aliases
        bucketlist: "bucket_list",
        "bucket-list": "bucket_list",
        bucket_list: "bucket_list",
        "bucket list": "bucket_list",

        // recommendations aliases
        recs: "recommendations",
        reco: "recommendations",
        recommendation: "recommendations",
        recommendations_list: "recommendations",
        agent_favorites: "recommendations",
        "agent-favorites": "recommendations",
        local_favorites: "recommendations",
        "local-favorites": "recommendations",
        favorites: "recommendations",
        faves: "recommendations",
        fav: "recommendations",

        // emergency aliases
        emergency: "emergency",
        emergency_info: "emergency",
        "emergency-info": "emergency",
        ice: "emergency",
        in_case_of_emergency: "emergency",
        "in-case-of-emergency": "emergency",

        // guestbook aliases
        guest_book: "guestbook",
        "guest-book": "guestbook",
        guestbooks: "guestbook",

        // Home Maintenance / Home HQ aliases
home: "home_maintenance",
homemaintenance: "home_maintenance",
"home-maintenance": "home_maintenance",
home_maintenance: "home_maintenance",
"home maintenance": "home_maintenance",
homehq: "home_maintenance",
home_hq: "home_maintenance",
"home-hq": "home_maintenance",
"home hq": "home_maintenance",

        // process tracker aliases
        process: "process_tracker",
        "process-tracker": "process_tracker",
        process_tracker: "process_tracker",
        tracker: "process_tracker",
        journey: "process_tracker",
        journey_tracker: "process_tracker",
        pipeline: "process_tracker",
        pipeline_tracker: "process_tracker",
      };

      if (alias[t]) t = alias[t];
      return t || "gift";
    };

  TS.isEditMode =
    TS.isEditMode ||
    function isEditMode() {
      return String(TS.q("mode") || "").trim().toLowerCase() === "edit";
    };

  // ---------- Device unlock ----------
  TS.activationStorageKey =
    TS.activationStorageKey ||
    function activationStorageKey(code) {
      return "ts_activated_" + String(code || "").trim().toUpperCase();
    };

  TS.isUnlockedOnThisDevice =
    TS.isUnlockedOnThisDevice ||
    function isUnlockedOnThisDevice(code) {
      try {
        return localStorage.getItem(TS.activationStorageKey(code)) === "1";
      } catch (e) {
        return false;
      }
    };

  // ---------- Cap Registry ----------
  TS.registerCap =
    TS.registerCap ||
    function registerCap(type, handlers) {
      const t = TS.normType(type);
      TS.caps[t] = handlers || {};
      log("Cap registered:", t);
    };

  TS.runCap =
    TS.runCap ||
    async function runCap(type, mode, gift) {
      const t = TS.normType(type);
      const cap = TS.caps[t] || TS.caps["gift"];
      if (!cap) throw new Error(`No cap registered for type "${t}" and no gift fallback.`);

      const fn = mode === "unclaimed" ? cap.unclaimed : cap.claimed;
      if (typeof fn !== "function") {
        throw new Error(`Cap "${t}" missing handler for mode "${mode}".`);
      }
      return await fn(gift);
    };

  log("Cap registry ready ✅");

  // ---------- Lazy-load cap by type ----------
  async function ensureCapLoaded(type, cfg) {
    try {
      cfg = cfg || {};
      const capUrls = cfg.CAP_URLS || {};
      const t = TS.normType(type);
      const src = capUrls[t] || capUrls["gift"];

      // If no mapping, do nothing (works if you ever re-add "load all caps")
      if (!src) return true;

      // Hub must provide this
      if (!window.TS_SHARED || typeof window.TS_SHARED.loadScriptOnce !== "function") {
        warn("CAP_URLS set but TS_SHARED.loadScriptOnce missing (hub should provide it).");
        return true;
      }

      await window.TS_SHARED.loadScriptOnce(src);
      return true;
    } catch (e) {
      warn("Cap lazy-load failed (continuing):", e);
      return false;
    }
  }

  // ---------- Supabase Fetch (with timeout) ----------
  async function fetchGiftByCode(code, cfg) {
    const SUPABASE_URL = cfg && cfg.SUPABASE_URL;
    const SUPABASE_ANON_KEY = cfg && cfg.SUPABASE_ANON_KEY;

    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
      throw new Error("Missing TS_CONFIG.SUPABASE_URL or TS_CONFIG.SUPABASE_ANON_KEY");
    }

    const url =
      `${SUPABASE_URL}/rest/v1/gift_codes` +
      `?code=eq.${encodeURIComponent(code)}` +
      `&select=*`;

    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 10000);

    const res = await fetch(url, {
      signal: ctrl.signal,
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      },
    }).finally(() => clearTimeout(timer));

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`Supabase fetch failed (${res.status}): ${txt}`);
    }

    const rows = await res.json();
    return Array.isArray(rows) ? rows[0] : null;
  }

  function showFatal(msg) {
    try {
      const el = (window.TS_SHARED && window.TS_SHARED.card) || document.getElementById("ts-card");
      if (el) el.innerHTML = `<p class="ts-error">${msg}</p>`;
    } catch (_) {}
  }

  // ---------- Bridge registrations ----------
  function must(fnName) {
    const fn = window[fnName];
    if (typeof fn !== "function") {
      warn(`Renderer not found yet: window.${fnName} (OK until first run)`);
    }
    return async (gift) => {
      const f = window[fnName];
      if (typeof f !== "function") throw new Error(`Missing renderer: window.${fnName}`);
      return await f(gift);
    };
  }

  // Activation gate is owned by the hub
  const activation = must("renderActivationGate");

  // Register caps as stubs (claimed renderers will exist after cap JS loads)
  TS.registerCap("gift", { claimed: must("renderClaimedGift"), unclaimed: activation });
  TS.registerCap("wifi", { claimed: must("renderClaimedWifi"), unclaimed: activation });
  TS.registerCap("pet", { claimed: must("renderClaimedPet"), unclaimed: activation });
  TS.registerCap("pet_care", { claimed: must("renderClaimedPetCare"), unclaimed: activation });
  TS.registerCap("military", { claimed: must("renderClaimedMilitary"), unclaimed: activation });
  TS.registerCap("grocery", { claimed: must("renderClaimedGrocery"), unclaimed: activation });
  TS.registerCap("business", { claimed: must("renderClaimedBusiness"), unclaimed: activation });
  TS.registerCap("chore", { claimed: must("renderClaimedChore"), unclaimed: activation });
  TS.registerCap("love_notes", { claimed: must("renderClaimedLoveNotes"), unclaimed: activation });
  TS.registerCap("prayer", { claimed: must("renderClaimedPrayer"), unclaimed: activation });
  TS.registerCap("prayer_board", { claimed: must("renderClaimedPrayerBoard"), unclaimed: activation });
  TS.registerCap("recipe_book", { claimed: must("renderClaimedRecipeBook"), unclaimed: activation });
  TS.registerCap("kindness", { claimed: must("renderClaimedKindness"), unclaimed: activation });
  TS.registerCap("bucket_list", { claimed: must("renderClaimedBucketList"), unclaimed: activation });
  TS.registerCap("recommendations", { claimed: must("renderClaimedRecommendations"), unclaimed: activation });
  TS.registerCap("emergency", { claimed: must("renderClaimedEmergency"), unclaimed: activation });
  TS.registerCap("process_tracker", { claimed: must("renderClaimedProcessTracker"), unclaimed: activation });
  TS.registerCap("guestbook", { claimed: must("renderClaimedGuestbook"), unclaimed: activation });
  TS.registerCap("home_maintenance", {
  claimed: must("renderClaimedHomeMaintenance"),
  unclaimed: activation
});
  TS.registerCap("group_gift", { claimed: must("renderClaimedGroupGift"), unclaimed: activation });

  // ---------- Core Start (Router) ----------
  // NOTE: Hub is responsible for calling TS.start() (NO auto-start here).
  TS.start =
    TS.start ||
    async function start() {
      try {
        const cfg = window.TS_CONFIG || {};

        const rawCode = String(TS.getCode() || "").trim().toUpperCase();
        if (!rawCode) {
          warn("Missing code in URL (?code=XXXX or #XXXX).");
          showFatal("Missing TapSake code in the URL. Try ?code=XXXX or #XXXX.");
          return;
        }

        const gift = await fetchGiftByCode(rawCode, cfg);
        if (!gift) {
          err("Code not found:", rawCode);
          showFatal("This TapSake code was not found.");
          return;
        }

        const type = TS.normType(gift.type || "gift");
        let status = String(gift.status || "claimed").trim().toLowerCase();
        const isEdit = TS.isEditMode();

        // ✅ If unlocked on this device, treat unclaimed as claimed
        if (status === "unclaimed" && TS.isUnlockedOnThisDevice(rawCode)) {
          status = "claimed";
        }

        log("Route:", { code: rawCode, type, status, isEdit });

        // ✅ KEY: Always lazy-load the cap BEFORE trying to render anything for that type.
        // This ensures:
        // - Claimed renderer exists
        // - If unclaimed pages need type-specific UI, it can be present
        await ensureCapLoaded(type, cfg);

        // Business activation/setup must not be bypassed by generic device unlock
        // or a global edit handler. Claimed visitor pages remain public.
        if (type === "business") {
          if (String(gift.status || "claimed").toLowerCase() === "unclaimed" || isEdit) {
            if (typeof window.renderUnclaimedBusiness !== "function") throw new Error("Business setup could not load.");
            await window.renderUnclaimedBusiness(gift, String(gift.status).toLowerCase() === "claimed");
          } else {
            await TS.runCap(type, "claimed", gift);
          }
          return;
        }

        // Optional global edit handler (rare)
        if (isEdit && typeof window.renderEditForm === "function") {
          await window.renderEditForm(gift);
          return;
        }

        // Unclaimed (normal) => activation gate
        if (status === "unclaimed" && !isEdit) {
          await TS.runCap(type, "unclaimed", gift);
          return;
        }

        // Unclaimed + edit mode => show claimed so cap can show edit UI
        if (status === "unclaimed" && isEdit) {
          await TS.runCap(type, "claimed", gift);
          return;
        }

        // Claimed (default)
        await TS.runCap(type, "claimed", gift);
      } catch (e) {
        err("Core start error:", e);
        if (e && e.name === "AbortError") {
          showFatal("This TapSake is taking too long to load. Please refresh and try again.");
          return;
        }
        showFatal("Something went wrong loading this TapSake. Check console for errors.");
      }
    };

  log("TS.start ready ✅");
})();
